import { I18nBinding } from './countries'
import { getCurrentGeoarea } from './geo'
import { Geoarea } from './geoareas'

const currentGeoarea = getCurrentGeoarea()

export const selectSupportedLangs = ({
  country: { localeCode, langLabel, secondaryLangs, i18nFile, languageCode },
}: Geoarea): I18nBinding[] => {
  return [
    {
      localeCode,
      langLabel,
      i18nFile,
      languageCode,
    },
    ...secondaryLangs,
  ]
}
export const getSupportedLangs = (...geoareas: Geoarea[]) =>
  (geoareas.length ? geoareas : [currentGeoarea]).flatMap(selectSupportedLangs)
